import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
    <a href = "/">back</a>
      <h1>Privacy Policy</h1>
      <p>
        This privacy policy explains how we collect, use, and protect your personal data when you use our website, lonescore.com.
      </p>
      <h2>Information We Collect</h2>
      <p>
        We may collect personal information such as your name, email address, and other details when you subscribe to our newsletter or use our services.
      </p>
      <h2>How We Use Your Information</h2>
      <p>
        Your information is used to personalize your experience, improve our website, and serve relevant ads using Google AdSense.
      </p>
      <h2>Third-Party Services</h2>
      <p>
        We use third-party services like Google AdSense and Google Analytics to display ads and analyze traffic on our site. These services may collect data such as your IP address or browser cookies.
      </p>
      <h2>Your Rights</h2>
      <p>
        You have the right to request access to or deletion of your personal data. To exercise these rights, please contact us at contact@lonescore.com.
      </p>
      <h2>Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us at contact@lonescore.com.
      </p>
    </div>
    
  );
};

export default PrivacyPolicy;
